import React, {useContext, useEffect, useState} from 'react';
import AuthContext from "../../Services/AuthContext";
import {Alert, Button, FormControlLabel, Stack, TextField, Typography} from "@mui/material";
import {useOutletContext, useParams} from "react-router-dom";
import Switch from "@mui/material/Switch";
import DatePicker from "../../Component/DatePicker";
import dbDate from "../../Utilities/dbDate";


function ChildrenOverview(props) {
    const description = (
        <Alert severity="warning"><strong>Zwróć uwagę na poprawność zgłaszanych danych.</strong><br/>Organizatorzy mogą
            na ich podstawie podejmować decyzję o zapisie na wydarzenie.</Alert>);


    const {children} = useOutletContext();
    const params = useParams();
    const [user] = useContext(AuthContext);
    const [alerts, setAlerts] = useState([]);
    const [finalStep, setFinalStep] = useState(false);
    const [file, setFile] = useState(null);
    const [message, setMessage] = useState('');

    const success = {
        'priority': 'Pesel dziecka jest w bazie danych organizatora',
        'extended_data': 'Uzupełniono wszystkie dane o dziecku',
        'allowed': 'Dodano przynajmniej wszystkich opiekunów prawnych do odbioru dziecka',
        'agreement': 'Wypełniono zgody organizatora',
        'documents': 'Podpisano zgloszenie elektronicznie',
        'birthday': 'Dziecko jest w odpowiednim wieku'
    };

    const error = {
        'priority': 'Pesel dziecka nie jest w bazie danych organizatora',
        'extended_data': 'Nie uzupełniono pełnych danych o dziecku',
        'allowed': 'Brak pełnej listy opiekunów do odbioru',
        'agreement': 'Nie wypełniono zgód organizatora',
        'documents': 'Nie złożono wniosków elektronicznie',
        'birthday': 'Dziecko nie spełnia wymagań dotyczących wieku przez organizatora'
    };

    function _prepareToSign() {

        fetch(`/api/qualification/${children}/${params.id}/sign`, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then((data) => {
                if (data[0].startsWith('https://podpis.gov.pl/')) {
                    window.open(data[0], '_blank');
                } else {
                    console.log(data);
                }
            })
            .catch(err => {
                console.log(err)
            })
    }
    function _send() {
        setMessage('');
        const data = new FormData();
        data.append('file', file);

        fetch(`/api/qualification/${children}/${params.id}/verify`, {
            method: 'POST',
            body: data,
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then((data) => {
                if (data?.success) {
                    setMessage(<Alert color={'success'}>{data.success}</Alert>)
                } else {
                    setMessage(<Alert color={'error'}>{data.error}</Alert>)
                }
            })
            .catch(err => {
                console.log(err)
            })
    }

    useEffect(() => {
        const abortController = new AbortController();

        async function fetchData() {
            await fetch(`/api/children/${children}/season/${params.id}`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    let isAllGood = true;
                    setAlerts(data.map((item) => {
                        if (item.value) return <Alert color={'success'}>{success[item.key]}</Alert>;
                        isAllGood = false;
                        return <Alert color={'error'}>{error[item.key]}</Alert>;
                    }));
                    setFinalStep(isAllGood);
                })
                .catch(err => {
                    console.log(err)
                })
        }

        fetchData();
        return () => abortController.abort();
    }, [children, user, params])

    return (<Stack direction={'column'} spacing={2}>
        {alerts}
        {finalStep && alerts.length > 0 && <>
            <Typography variant={'body2'}>Tu wygenerujesz gotową kartę kwalifikacyjną dziecka. Kartę należy podpisać za pomocą podpisu zaufanego lub podpisu kwalifikowanego. <strong>Za pomocą przycisku poniżej przejdziesz do podpisu zaufanego. Po weryfikacji i podpisaniu dokumentu pobierz go i prześlij do nas.</strong></Typography>
            <a href={`/api/qualification/${children}/${params.id}/preview?auth=${user.token}`} target={"_blank"}><Button
                variant={'outlined'}>Podgląd Karty Kwalifikacyjnej</Button></a>
            <Button color={'warning'} variant={'contained'} onClick={_prepareToSign}>Przejdź do Podpis.gov.pl</Button>

            <Typography variant={'h6'}>Podpisany wniosek prześlij tutaj</Typography>
            <input type="file" name="file" onChange={(e) => setFile(e.target.files[0])}/>
            <Button color={'primary'} variant={'contained'} onClick={_send}>Załącz podpisany dokument</Button>
            {message}
        </>
        }
    </Stack>);
}

export default ChildrenOverview;